(function () {
  'use strict';

  /* ── Deck Carousel ───────────────────────────────────────────────────────── */

  class RPDeckCarousel {
    constructor(deckEl) {
      this.el      = deckEl;
      this.stage   = deckEl.querySelector('.rp-deck__stage');
      this.track   = deckEl.querySelector('.rp-deck__track');
      this.slides  = [...deckEl.querySelectorAll('.rp-deck__slide')];
      this.dots    = [...deckEl.querySelectorAll('.rp-deck__dot')];
      this.current = 0;
      this.total   = this.slides.length;
      this.speed   = (parseInt(deckEl.dataset.deckSpeed, 10) || 5) * 1000;
      this.timer   = null;
      this.busy    = false;

      if (this.total < 2) return;

      // Enable CSS transitions after first paint so slide 1 doesn't animate in on load
      requestAnimationFrame(() => this.track.classList.add('transitions-on'));

      // Dot clicks
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.index, 10);
          const dir = idx > this.current ? 1 : -1;
          this.goTo(idx, dir);
          this._restartTimer();
        });
      });

      // Arrow buttons
      deckEl.querySelector('.rp-deck__btn--prev')?.addEventListener('click', () => {
        this.go(-1);
        this._restartTimer();
      });
      deckEl.querySelector('.rp-deck__btn--next')?.addEventListener('click', () => {
        this.go(1);
        this._restartTimer();
      });

      // Pause on hover, resume on leave
      deckEl.addEventListener('mouseenter', () => this._pause());
      deckEl.addEventListener('mouseleave', () => this._play());

      // Touch swipe on the stage
      this._bindTouch();

      this._play();
    }

    go(dir) {
      const next = (this.current + dir + this.total) % this.total;
      this.goTo(next, dir);
    }

    goTo(index, direction) {
      if (this.busy || index === this.current) return;
      this.busy = true;

      const fromSlide = this.slides[this.current];
      const toSlide   = this.slides[index];

      // Direction: +1 means incoming slides from right, outgoing exits left
      const d = direction >= 0 ? 1 : -1;

      // 1. Position incoming slide off-screen (no transition yet)
      toSlide.style.transition = 'none';
      toSlide.style.transform  = `translateX(${d * 100}%)`;
      toSlide.style.opacity    = '0';
      toSlide.classList.remove('is-active', 'is-exiting');

      // 2. Force reflow so the browser registers the starting position
      toSlide.offsetHeight; // eslint-disable-line no-unused-expressions

      // 3. Re-enable transitions and animate both slides simultaneously
      toSlide.style.transition = '';
      toSlide.style.transform  = '';
      toSlide.style.opacity    = '';
      toSlide.classList.add('is-active');

      fromSlide.style.transform = `translateX(${d * -100}%)`;
      fromSlide.style.opacity   = '0';
      fromSlide.classList.remove('is-active');

      // 4. Update dots
      this.dots[this.current]?.classList.remove('is-active');
      this.dots[this.current]?.setAttribute('aria-selected', 'false');
      this.dots[index]?.classList.add('is-active');
      this.dots[index]?.setAttribute('aria-selected', 'true');

      this.current = index;

      // 5. Clean up outgoing slide after transition ends
      setTimeout(() => {
        fromSlide.style.transition = 'none';
        fromSlide.style.transform  = '';
        fromSlide.style.opacity    = '';
        fromSlide.offsetHeight; // eslint-disable-line no-unused-expressions
        fromSlide.style.transition = '';
        this.busy = false;
      }, 660);
    }

    _play() {
      this._pause();
      this.timer = setInterval(() => this.go(1), this.speed);
    }

    _pause() {
      clearInterval(this.timer);
      this.timer = null;
    }

    _restartTimer() {
      this._pause();
      this._play();
    }

    _bindTouch() {
      if (!this.stage) return;
      let startX = 0;
      this.stage.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });
      this.stage.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 44) {
          this.go(dx < 0 ? 1 : -1);
          this._restartTimer();
        }
      });
    }
  }


  /* ── Init ─────────────────────────────────────────────────────────────────── */

  function init() {
    document.querySelectorAll('.rp-pitch-deck').forEach((section) => {
      const deckEl = section.querySelector('.rp-deck');
      if (deckEl) new RPDeckCarousel(deckEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
